var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "17b246ba-e48c-4447-a510-985ae9d9cb33"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "684c62cc-de31-4fd1-a724-b15501bb028b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(61,171,193)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-2559.88, -2559.19)",
    d: "M 2365 5094 C 2249 5082 2145 5067 2055 5049 C 1064 4851 269 4056 71 3065 C 33 2877 25 2788 25 2560 C 25 2207 75 1938 197 1630 C 591 631 1575 -15 2645 23 C 3301 47 3897 306 4357 768 C 4759 1172 4998 1660 5082 2245 C 5099 2363 5099 2757 5082 2875 C 4998 3460 4759 3948 4357 4352 C 3966 4744 3481 4988 2920 5075 C 2819 5090 2453 5103 2365 5094 z M 2910 4885 C 3389 4810 3831 4592 4191 4253 C 4360 4093 4550 3832 4663 3605 C 4744 3443 4792 3315 4835 3146 C 4890 2929 4905 2804 4905 2560 C 4904 2316 4889 2187 4835 1975 C 4625 1151 3969 495 3145 285 C 2931 231 2804 216 2560 216 C 2316 216 2189 231 1974 285 C 1151 494 496 1149 285 1974 C 229 2193 215 2306 215 2560 C 215 2814 229 2927 285 3146 C 428 3706 776 4193 1260 4515 C 1590 4735 1946 4860 2365 4904 C 2453 4913 2809 4901 2910 4885 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 0.01 -0.16)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(61,171,193)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-2559.94, -2560.4)",
    d: "M 2335 4488 C 2291 4483 2204 4468 2141 4454 C 1254 4255 620 3466 620 2560 C 620 1819 1050 1135 1719 813 C 2459 457 3335 603 3920 1180 C 4689 1939 4694 3167 3930 3930 C 3512 4349 2923 4555 2335 4488 z M 2760 4299 C 3034 4266 3292 4172 3510 4030 C 3625 3954 3682 3909 3778 3816 C 4260 3351 4432 2648 4220 2010 C 4136 1755 4009 1544 3825 1351 C 3295 796 2464 651 1779 994 C 1186 1291 810 1897 810 2555 C 810 2757 837 2921 901 3114 C 1113 3753 1674 4212 2350 4299 C 2445 4311 2663 4312 2760 4299 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 0.02 -0.11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(61,171,193)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-2560, -2560)",
    d: "M 2498 3725 C 2464 3692 2460 3664 2460 3494 L 2460 3350 L 2291 3350 L 2123 3350 L 2096 3324 L 2070 3297 L 2070 2911 C 2070 2480 2069 2490 2138 2470 C 2160 2464 2313 2460 2518 2460 L 2860 2460 L 2860 2210 L 2860 1960 L 2510 1960 C 2137 1960 2105 1956 2081 1912 C 2061 1875 2068 1825 2096 1796 L 2123 1770 L 2291 1770 L 2460 1770 L 2460 1626 C 2460 1456 2464 1428 2498 1395 C 2550 1343 2639 1375 2654 1451 C 2657 1469 2660 1547 2660 1626 L 2660 1770 L 2829 1770 L 2997 1770 L 3024 1796 L 3050 1823 L 3050 2209 C 3050 2640 3051 2630 2982 2650 C 2960 2656 2807 2660 2603 2660 L 2260 2660 L 2260 2910 L 2260 3160 L 2610 3160 C 2983 3160 3015 3164 3039 3208 C 3059 3245 3052 3295 3024 3324 L 2997 3350 L 2829 3350 L 2660 3350 L 2660 3494 C 2660 3573 2657 3651 2654 3669 C 2639 3745 2550 3777 2498 3725 z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8c9a94aee80f8f5f31186c257caa2737.svg";
export { ForwardRef as ReactComponent };